import React from 'react';
import {
    BasicInfo,
    LoginInfo,
    Integrations,
    ProfileSettings,
    NotificationSettings,
} from '~/components/Profile';

export function Profile() {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12 col-lg-6 mb-4">
                    <LoginInfo />
                    <Integrations />
                </div>
                <div className="col-12 col-lg-6">
                    <BasicInfo />
                    <ProfileSettings />
                    <NotificationSettings />
                </div>
            </div>
        </div>
    );
}
